import React from 'react';
import FilterControl from '../FilterControl';
import { ViewFilterName } from '../../../../enum/types/ViewFilterName';

const FavouriteFilterSection: React.FC = () => {
  return (
    <>
      <FilterControl name={ViewFilterName.Favorite} />
    </>
  );
};

export default FavouriteFilterSection;
